import { Dispatch } from 'redux';
import { requestFieldNamesByOperations } from '../requesters/uapiFieldsRequester/uapiFieldsRequester';
import {
  receiveFieldSearchIndex,
  fieldSearchIndexFailure,
  clearFieldNameSearch,
  searchFieldsByName,
} from '../actions/fieldsActions';
import type { FieldsActions } from '../actions/fieldsActions';
import { logDmbErrorLocation } from '../utils/error';
import type { OperationCurrent } from '../utils/operationUtils';
import { resolveCurrentOperationId } from '../utils/operationUtils';

interface UapiFieldsState {
  operations: {
    current: OperationCurrent;
    allIds: string[];
  };
}

export const fetchFieldSearchIndex = (operationIds: string[]) =>
  async (dispatch: Dispatch<FieldsActions>, getState: () => UapiFieldsState): Promise<void> => {
    try {
      const { operations } = getState();
      const currentOpId = resolveCurrentOperationId(operations.current, operationIds);
      const priorityIds = currentOpId ? [currentOpId] : [];
      const remainingIds = operationIds.filter((id) => id !== currentOpId);

      if (priorityIds.length > 0) {
        const priorityIndex = await requestFieldNamesByOperations(priorityIds);
        dispatch(receiveFieldSearchIndex(priorityIndex));
      }

      if (remainingIds.length > 0) {
        const remainingIndex = await requestFieldNamesByOperations(remainingIds);
        dispatch(receiveFieldSearchIndex(remainingIndex));
      }
    } catch (error) {
      dispatch(fieldSearchIndexFailure());
      logDmbErrorLocation(error, 'uapiFieldsThunks - fetchFieldSearchIndex');
    }
  };

export const fetchFieldNameSearch = (searchTerm: string) =>
  (dispatch: Dispatch<FieldsActions>): void => {
    if (!searchTerm || searchTerm.trim().length === 0) {
      dispatch(clearFieldNameSearch());
      return;
    }

    dispatch(searchFieldsByName(searchTerm));
  };
